export default "__VITE_ASSET__CPVR2G82__$_?url__"